import client from '@/ports/api-client'
import { useQuery } from '@tanstack/react-query'

const fetchZapierIntegration = async () => {
  const response = await client.get(`/external_api_key_pair`, {
    noLoading: true
  })
  return response
}

const useGetZapierIntegration = () => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ['fetchData'],
    queryFn: fetchZapierIntegration,
    enabled: false
  })

  const fetchData = () => refetch()

  return { data, error, isLoading, fetchData }
}

export default useGetZapierIntegration
